import { cn } from "@/utils";
import React from "react";
import { FaFilePdf, FaFileWord, FaFileExcel, FaFile } from "react-icons/fa";

const EXT_ICON_MAP = {
  pdf: FaFilePdf,
  doc: FaFileWord,
  docx: FaFileWord,
  xls: FaFileExcel,
  xlsx: FaFileExcel,
  zip: FaFile,
  // thêm nữa theo nhu cầu
};

const ClassExtIcon = {
  pdf: "text-red-500",
  doc: "text-blue-500",
  docx: "text-blue-500",
  xls: "text-green-700",
  xlsx: "text-green-700",
  zip: "text-gray-500",
};

const FileIcon = React.memo(
  ({
    url,
    fileName,
    ext,
    isDownload = true,
  }: {
    url?: string | null;
    fileName?: string | null;
    ext?: string | null;
    isDownload?: boolean;
  }) => {
    if (!url) return null;
    const IconComp = EXT_ICON_MAP[ext as keyof typeof EXT_ICON_MAP] || FaFile;

    return (
      <div className="flex items-center gap-[8px] p-4">
        <IconComp
          className={cn(
            "size-4",
            ClassExtIcon[ext as keyof typeof EXT_ICON_MAP] || "",
          )}
        />

        {isDownload ? (
          <a href={url} download target="_self" className="underline">
            {fileName}
          </a>
        ) : (
          <p>{fileName}</p>
        )}
      </div>
    );
  },
);

export { FileIcon };
